import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.financial.'

@vsingleton()
export class AdminTransactionRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'transactions.'

  index() {
    return this.ziggyRoute('index')
  }

  show(id) {
    return this.ziggyRoute('show', id)
  }

  setPaid(id) {
    return this.ziggyRoute('set_paid', id)
  }

  reject(id) {
    return this.ziggyRoute('reject', id)
  }

}